
import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Loader2 } from 'lucide-react';
import { useProductAnalytics } from '@/hooks/product/useProductAnalytics';
import { TimeRangeSelector } from '@/components/analytics/TimeRangeSelector';
import { AnalyticsOverview } from '@/components/product/analytics/AnalyticsOverview';
import { ClicksOverTimeChart } from '@/components/product/analytics/ClicksOverTimeChart';
import { ClicksByCategoryChart } from '@/components/product/analytics/ClicksByCategoryChart';
import { TopProductsChart } from '@/components/product/analytics/TopProductsChart';

const ProductAnalytics = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const {
    loading,
    clicksByDate,
    clicksByCategory,
    clicksByProduct,
    totalClicks,
    previousTotalClicks,
    clicksGrowth,
    timeRange,
    setTimeRange
  } = useProductAnalytics();

  const topCategory = clicksByCategory.length > 0 ? clicksByCategory[0] : null;
  const topProduct = clicksByProduct.length > 0 ? clicksByProduct[0] : null;

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold">Product Analytics</h1>
          <p className="text-muted-foreground">Track and analyze product performance with period-over-period comparison.</p>
        </div>
        
        <div className="flex items-center space-x-2">
          <TimeRangeSelector value={timeRange} onChange={setTimeRange} />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="ml-2 text-muted-foreground">Loading analytics data...</p>
        </div>
      ) : (
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="clicks-by-date">Clicks By Date</TabsTrigger>
            <TabsTrigger value="clicks-by-category">Clicks By Category</TabsTrigger>
            <TabsTrigger value="top-products">Top Products</TabsTrigger>
          </TabsList>
          
          <TabsContent value="overview">
            <AnalyticsOverview 
              totalClicks={totalClicks}
              previousTotalClicks={previousTotalClicks}
              clicksGrowth={clicksGrowth}
              topCategory={topCategory} 
              topProduct={topProduct} 
            />
            <ClicksOverTimeChart data={clicksByDate} />
          </TabsContent>
          
          <TabsContent value="clicks-by-date">
            <ClicksOverTimeChart data={clicksByDate} />
          </TabsContent>
          
          <TabsContent value="clicks-by-category">
            <ClicksByCategoryChart data={clicksByCategory} />
          </TabsContent>
          
          <TabsContent value="top-products">
            <TopProductsChart data={clicksByProduct} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
};

export default ProductAnalytics;
